// extracted by mini-css-extract-plugin
export default {"option-list-container":"NabTabsMenuButton_option-list-container__rR6dd","optionListContainer":"NabTabsMenuButton_option-list-container__rR6dd","icon":"NabTabsMenuButton_icon__fMuUx"};